import styled from "styled-components";

export const CommentInfoWrapper = styled.div`
  padding: 1.375rem;
`;

export const CommentInfoText = styled.div`
  display: grid;
  grid-template-columns: 16rem 1fr;
  margin-bottom: 1.375rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const CommentTitleText = styled.h2`
  color: #ed6b08;
  font-size: 1rem;
  font-family: lato;
  text-transform: initial;
  margin: 0;
  line-height: 1;
  font-weight: bold;
`;

export const CommentTitleValue = styled.p`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 1rem;
`;
